var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22V18M8 20V18M16 20V18",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7 17.001C20.552 16.8404 21.1947 16.5724 21.7112 16.1251C23 15.0092 23 13.2131 23 9.621C23 6.02888 23 4.23283 21.7112 3.1169C20.4226 2.00098 18.3483 2.00098 14.2 2.00098H9.8C5.65164 2.00098 3.57747 2.00098 2.28873 3.1169C1 4.23283 1 6.02888 1 9.621C1 13.2131 1 15.0092 2.28873 16.1251C2.8053 16.5724 3.44805 16.8404 4.3 17.001",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5015 10H18.4922",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50929 10H5.5",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.4923C14.5216 13.3957 13.6512 14 12.6568 14C11.147 14 9.92308 12.6071 9.92308 10.8889V9.1111C9.92308 7.39289 11.147 6 12.6568 6C13.6512 6 14.5216 6.60426 15 7.50774M9 10H12.9231",
    stroke: "#5754E5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTCash);
export default __webpack_public_path__ + "static/media/iconTCash.9e18f216d2c2ecd4b2604ba28afc250b.svg";
export { ForwardRef as ReactComponent };